
import BaseModal from '@marketplace/components/BaseModal.vue'
import { MARK_TRADEMART_PARTNERSHIP_MODAL_SEEN } from '@marketplace/graphql/trademart.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalTrademartPartnership',

    components: {
        BaseModal,
    },

    props: {
        hideCloseButton: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            isSubmitting: false,
        }
    },

    methods: {
        async acknowledge() {
            if (this.isSubmitting) {
                return
            }

            this.isSubmitting = true

            try {
                const { data } = await this.$apollo.mutate({
                    mutation: MARK_TRADEMART_PARTNERSHIP_MODAL_SEEN,
                })

                const { userErrors } =
                    data?.markTrademartPartnershipModalSeen || {}

                if (!userErrors?.length) {
                    this.$store.commit('global/updateUserData', {
                        shouldShowTrademartPartnershipModal: false,
                    })
                }
            } finally {
                this.$vfm.hideAll()
                EventBus.$emit('reset-modal-trigger-flag')
                this.isSubmitting = false
            }
        },
    },
}
